import React, { useState, useEffect, useCallback } from 'react';
import { WSREST_TABATA } from '../../config';
import {formatCurrency } from '../../utils/Utils';
import Card from '../../components/card/Card';
import { getMerlinoT } from '../../services/merlinoService';

function CardInfoOrdini({idordine}) {
    const [orderDetails, setOrderDetails] = useState(null);
    const fetchOrderDetails = useCallback(async () => {
    const url = `${WSREST_TABATA}ordertabb2c/orders/${idordine}`;
    const token = getMerlinoT();
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const data = await response.json();
                setOrderDetails(data.data);
            } else {
                console.error("Errore nella risposta dell'ordine:", response.status);
            }
        } catch (error) {
            console.error("Errore durante la fetch dell'ordine:", error);
        }
    }, [idordine]);

    useEffect(() => {
        fetchOrderDetails();
    }, [fetchOrderDetails]);

    const titolo = orderDetails
  ? `Ordine ${orderDetails.idordine || ''} - ${orderDetails.fonte === 'MAG' ? 'Magento' : orderDetails.fonte}`
  : 'Ordine';

    return (   
        
        <Card titoloCard={titolo}>
            {orderDetails ? (
                <>
                
					
                    <div className="d-sm-flex flex-sm-wrap">
						<div className="fw-semibold">Totale Omaggi:</div>
						<div className="ms-sm-auto mt-1 mt-sm-0">{formatCurrency(orderDetails.totsconto)}</div>
					</div>
                    <div className="d-sm-flex flex-sm-wrap">
						<div className="fw-semibold">Totale ordine:</div>
						<div className="ms-sm-auto mt-1 mt-sm-0">{formatCurrency(orderDetails.totdapagare)}</div>
					</div>
                    <div className="d-sm-flex flex-sm-wrap">
						<div className="fw-semibold">Totale pagato:</div>
						<div className="ms-sm-auto mt-1 mt-sm-0 mb-2">{formatCurrency(orderDetails.totpagato)}</div>
					</div>
                
                </>
            ) : (
                <></>
            )}
        </Card>
    );
}

export default CardInfoOrdini;